export const PERMISSIONS_TRACER = {
  BOOKINGS: {    
    VIEW: 'TRACER_BOOKING',
  },
  REP: {
    VIEW: 'RELIEF_PROFILE',
    RELIEF_PROFILE_ACTION: 'RELIEF_PROFILE_ACTION'
  },
  MANAGE_TEAM: {
    VIEW: 'TRACER_MANAGE_TEAM',
    TRACER_INVITE_TEAM: 'TRACER_INVITE_TEAM',
  },
  MY_SCHOOLS: {
    VIEW: 'TRACER_MY_SCHOOL',
  },
  PAYROLL:{
    TRACER_DOWNLOAD_REPORT: 'TRACER_DOWNLOAD_REPORT',
  },
  LEAVE_APPROVAL: 'TRACER_LEAVE_APPROVAL',
  PAGE_NOT_FOUND: 'TRACER_PAGE_NOT_FOUND',
} as const;